import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/roles/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/roles`, config),
    fetchAll: (config: AxiosRequestConfig) => api.get(`/roles/all`, config),
    fetchAllPermissions: (config: AxiosRequestConfig) => api.get(`/permissions/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/roles/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/roles`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/roles/${url.id}`, data, config),
};

export default requests;
